import { FunctionComponent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './BottomNavigation.module.css';
import { SvgIconComponent } from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/Home';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';

interface NavItem {
  path: string;
  label: string;
  icon: SvgIconComponent;
}

const BottomNavigation: FunctionComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems: NavItem[] = [
    { path: '/home', label: 'Search', icon: HomeIcon },
    { path: '/saved', label: 'Saved', icon: BookmarkIcon },
    { path: '/claims', label: 'Claims', icon: DescriptionIcon },
    { path: '/profile', label: 'Profile', icon: PersonIcon },
  ];

  const handleNavClick = (path: string) => {
    navigate(path);
  };

  return (
    <nav className={styles.bottomNavigation} aria-label="Primary">
      <div className={styles.navContainer}>
        {navItems.map((item) => {
          const IconComponent = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              className={`${styles.navItem} ${isActive ? styles.active : ''}`}
              onClick={() => handleNavClick(item.path)}
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
            >
              <div className={styles.navIcon}>
                <IconComponent 
                  style={{ 
                    fontSize: '24px',
                    color: isActive ? 'var(--color-brand-600)' : 'var(--color-slate-600)'
                  }}
                />
              </div>
              <div className={styles.navLabel} style={{ color: isActive ? 'var(--color-brand-600)' : undefined }}>{item.label}</div>
            </button>
          );
        })}
      </div>
      {/* <div className={styles.bottomBar} /> */}
    </nav>
  );
};

export default BottomNavigation;
